import React from 'react'
import { node, string } from 'prop-types'

import { getAdditionalLinkAttributes } from '@jelly/utils'

AnchorTag.propTypes = {
	children: node.isRequired,
	href: string,
}

/**
 * AnchorTag - common component
 * It accepts:
 * - an href
 * - any other prop you want
 * Additionally, it features:
 * - a spread operator to handle onClick, className, style, etc
 **/
export function AnchorTag({ children, href, ...additionalAttributes }) {
	return (
		<a href={href} {...additionalAttributes} {...getAdditionalLinkAttributes(href)}>
			{children}
		</a>
	)
}
